import { isNative } from "@/lib/capacitor";

const UNIVERSAL_LINK_ORIGIN = "https://figverified.com";

// For email-link redirects (verification, password reset). Universal links
// are right here: they open in the user's mail client and the mail app hands
// the URL to iOS, which routes it to FIG.
export function getAuthRedirectUrl(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const origin = isNative ? UNIVERSAL_LINK_ORIGIN : window.location.origin;
  return `${origin}${normalized}`;
}

// For OAuth redirects (Google, Apple via Supabase OAuth flow). On native we
// use a custom URL scheme so iOS hands control back to the FIG app at the
// end of the browser auth flow — universal links don't switch apps from a
// Safari-initiated redirect, so they leave the user stranded on the website.
// Web stays same-origin.
export function getOAuthRedirectUrl(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (isNative) {
    const queryStart = normalized.indexOf("?");
    const query = queryStart >= 0 ? normalized.slice(queryStart) : "";
    return `fig://login-callback${query}`;
  }
  return `${window.location.origin}${normalized}`;
}
